module.exports = __webpack_public_path__ + "way2go/static/config/cag_airline_code_mapping.csv";